// extracted by mini-css-extract-plugin
export default {"button-wrapper":"_1aDW3","buttonWrapper":"_1aDW3","dot":"_6lthC"};